"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMenuItem = exports.StyledMenuTriggerButton = exports.StyledMenu = exports.StyledLabel = exports.SelectDropdownContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme/");
const button_1 = require("@kyruus/button");
const menu_1 = __importStar(require("@kyruus/menu"));
exports.SelectDropdownContainer = styled_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};
`;
exports.StyledLabel = (0, styled_1.default)('label') `
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
`;
exports.StyledMenu = (0, styled_1.default)(menu_1.default) `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_small')};

  div.MuiPaper-root {
    width: ${({ anchorEl }) => (anchorEl ? `${anchorEl.clientWidth}px` : '0')};
    overflow-y: auto;
  }

  ul {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  ul > li {
    padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
    padding-top: calc(${(0, ui_theme_1.fromTheme)('spacing_large')} / 2);
    padding-bottom: calc(${(0, ui_theme_1.fromTheme)('spacing_large')} / 2);
  }

  ul > li:first-child {
    padding-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }

  ul > li:last-child {
    padding-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }
`;
exports.StyledMenuTriggerButton = (0, styled_1.default)(button_1.Button) `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  border-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
  background: ${(0, ui_theme_1.fromTheme)('color_background')};

  &:hover {
    background: transparent;
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
  }

  &:active {
    background: transparent;
    border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_link')};
    color: ${(0, ui_theme_1.fromTheme)('text_color')};
  }

  &:active:not(:disabled) {
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
    border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_link')};
    background: transparent;
  }

  &:focus {
    background: transparent;
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
    border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_link')};
  }
`;
exports.StyledMenuItem = (0, styled_1.default)(menu_1.MenuItem) `
  display: flex;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  padding: 0;

  > label {
    margin-bottom: 0;
    display: flex;
    align-items: center;

    p {
      font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
      color: ${(0, ui_theme_1.fromTheme)('color_text')};
      font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
      margin: 0;
      padding: 0;
      font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
    }
  }
`;
//# sourceMappingURL=styles.js.map